import { convertValueUnit } from '@metservicedev/cf-units';

const CARDINALS = ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW'];
const CARDINAL_ANGLES = [0, 22.5, 45, 67.5, 90, 112.5, 135, 157.5, 180, 202.5, 225, 247.5, 270, 292.5, 315, 337.5];

const normalizeDegree = (deg) => {
    return ((deg % 360) + 360) % 360;
};

const convertDirectionToCardinal = ({ value, unit }) => {
    // NB Requires CARDINALS to have 16 parts, 22.5 degrees per part
    unit = unit ? unit : 'deg';
    if (isNaN(value)) {
        return value;
    }
    let numberValue = normalizeDegree(parseFloat(value));
    numberValue = convertValueUnit({ value: numberValue, from: unit, to: 'deg' }); // Work in degrees
    numberValue = Math.floor((numberValue % 360) / 22.5 + 0.5);
    return CARDINALS[numberValue % 16];
};

const convertCardinalToDirection = ({ value, unit }) => {
    unit = unit ? unit : 'deg';
    const index = CARDINALS.indexOf(value);
    if (index < 0) return undefined;
    return convertValueUnit({ value: CARDINAL_ANGLES[index], from: 'deg', to: unit });
};

export { convertDirectionToCardinal, convertCardinalToDirection };
